import { Select } from "antd";
import React from "react";

const CustomSelect = ({ style = {}, size = "large", placeholder, onChange, onSearch, onClick, options = [], showSearch = true, ...props }) => {
    return (
        <Select style={{ ...style, background: "#FFFFFF", borderRadius: "8px" }} size={size} placeholder={placeholder} onChange={onChange} onSearch={onSearch} onClick={onClick} options={options} showSearch={showSearch} {...props} />
    )
};

export default CustomSelect;
